import { Component, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { GlobalVariables } from '../../../../../../common/global-variables';


@Component({
    selector: 'default-page-details-vc',
    styles: [],
    template: `
    <div>{{ 'vcDpsModule.placeholders.defaultDetailsPage' | translate }}</div>
    `
})
export class DefaultPageDetails {
    @Input('entity') entity: any;

    constructor(private translate:TranslateService) {
        translate.use(GlobalVariables.LOCALE);
    }
}


// WEBPACK FOOTER //
// ./src/app/components/dataprotection/dataprotection-vc/manage/default-page/default-page-details-vc.component.ts